const classes = Object.freeze({
    paper: 'll-select__paper ll-select__paper_language',
    list: 'll-select__list'
});

export {
    classes,
};